const ResidualTextDirective = function (Voucher, currencyFilter) {

  return {
    require: [ 'ngModel' ],
    restrict: 'A',
    scope: {
      template: "@residualtext"
    },
    link: function (scope, element) {
      scope.Voucher = Voucher;
      // if the value of the residual changed, we update the text
      scope.$watch('Voucher.residualValue', function () {
        element.text(
          scope.template.replace('[[XXX]]', currencyFilter(Voucher.residualValue))
        );
      });
    }
  };
};
/**
 * sets the text for the residual value of the voucher
 */
export default ResidualTextDirective;
